import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/system-settings")({
	component: SystemSettingsPage,
});

function SystemSettingsPage() {
	const { t } = useTranslation();

	return (
		<div className="space-y-6">
			<div>
				<h1 className="font-bold text-3xl">
					{t("admin:system_settings.title")}
				</h1>
			</div>

			<div className="rounded-lg border bg-card p-6 shadow-sm">
				<p className="text-muted-foreground">
					System settings management coming soon...
				</p>
			</div>
		</div>
	);
}
